export const GET_INSIDE_SALES_BOOKING_DATA_REQUEST = 'GET_INSIDE_SALES_BOOKING_DATA_REQUEST';
export const GET_INSIDE_SALES_BOOKING_DATA_SUCCESS = 'GET_INSIDE_SALES_BOOKING_DATA_SUCCESS';
export const GET_INSIDE_SALES_BOOKING_DATA_FAILURE = 'GET_INSIDE_SALES_BOOKING_DATA_FAILURE';
